import { render, staticRenderFns } from "./Garantiav.vue?vue&type=template&id=48369900&"
import script from "./Garantiav.vue?vue&type=script&lang=js&"
export * from "./Garantiav.vue?vue&type=script&lang=js&"
import style0 from "./Garantiav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports